import type { MaterialSubcategory } from '../../gql';

import { randBoolean, randProductCategory, randUuid } from '@ngneat/falso';

const mockMaterialSubcategory = (
    override?: Partial<MaterialSubcategory>
): MaterialSubcategory => ({
    materialSubcategoryPublicId: randUuid(),
    materialSubcategoryName: randProductCategory(),
    isDeleted: randBoolean(),
    isOnTheFlySupported: randBoolean(),
    unitOfMeasurementTypePublicId: randUuid(),
    isColourAllowed: randBoolean(),
    ...override,
    ['__typename']: 'MaterialSubcategory',
});

export { mockMaterialSubcategory };
